export { default } from './CardContent'


// WEBPACK FOOTER //
// ./src/components/CardContent/index.js